class Http
{
	static params(params, encode = true)
	{
		var res = [];

		for(var key in params)
		{
			var val = params[key];

			if(encode)
			{
				key = encodeURIComponent(key);
				val = encodeURIComponent(val);
			}

			res.push(`${key}=${val}`);
		}

		return res.join('&');
	}

    constructor(baseUrl, withCredentials)
    {
        this.baseUrl = baseUrl;
        this.withCredentials = withCredentials;
    }

	url(path, params)
	{
		var url = this.baseUrl + (path ? '/' + path : '');

		if(params && typeof params === 'object')
		{
			url += '?' + Http.params(params);
		}

		return url;
	}

	get(path, params, headers)
	{
		return this.fetch(path, 'GET', params, null, headers);
	}

	delete(path, params, headers)
	{
		return this.fetch(path, 'DELETE', params, null, headers);
	}

	put(path, params, body, headers)
	{
		return this.fetch(path, 'PUT', params, body, headers);
	}

	post(path, params, body, headers)
	{
		return this.fetch(path, 'POST', params, body, headers);
	}

	fetch(path, method = 'GET', params, body, headers)
	{
		const url = this.url(path, params);
		const crt = this.withCredentials;

		if(!headers || typeof headers !== 'object')
		{
			headers = {};
		}

		if(typeof body === 'object' && !(body instanceof HTMLFormElement))
		{
			body = JSON.stringify(body);
		}

		return new Promise(function(resolve, reject)
		{
			var req = new XMLHttpRequest();
			var res;

			req.open(method, url);
			req.withCredentials = crt;

			for(var key in headers)
			{
				req.setRequestHeader(key, headers[key]);
			}

			req.onload = function()
			{
				var code = this.status;
				var text = req.statusText;

				if(req.response && code >= 200 && code < 300)
				{
					try
					{
						res = JSON.parse(req.response);
					}
					catch(err)
					{
						console.warn('JSON error', url, code, text, err);
					}
				}

				resolve(res);
			}

			req.onerror = function()
			{
				var code = this.status;
				var text = req.statusText;

				console.warn('Fetch error', code, text);

				resolve(res);
			}

			req.send(body);
		})
	}
}

export default Http;